module.exports = __webpack_public_path__ + "img/works_beijing_xikemu_7.adf5a55e.jpg";